import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as Exchange from 'exchange/components';
import ExchangeFormHandlers from 'exchange/containers/ExchangeFormHandlers';

import { getVisibleCoins } from 'selectors/lists';
import { getIsSaving, getIsFetching, getEditing } from 'exchange/selectors';
import { getCompany } from 'auth/selectors';

class ExchangeFormContainer extends Component {
  render = () => (
    <ExchangeFormHandlers
      render={({ isSubmitted, isSaving, handleValueChange, handleValidation, handleSubmit }) => (
        <Exchange.FormView
          company={this.props.company}
          coins={this.props.coins}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          exchange={this.props.exchange}
          isFetching={this.props.isFetching}
          isSubmitted={isSubmitted}
          isSaving={isSaving}
        />
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  isSaving: getIsSaving(state),
  isFetching: getIsFetching(state),
  exchange: getEditing(state),
  company: getCompany(state),
  coins: getVisibleCoins(state),
});

export default connect(mapStateToProps, null)(ExchangeFormContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/containers/ExchangeFormContainer.js